import BliRadio from '@blibli/blue.radio/dist/radio/blue/Radio'

export default {
  name: 'TenantCard',
  components: {
    BliRadio
  },
  props: {
    tenantInfo: {
      type: Object,
      default: {},
      required: true
    },
    selectedTenant: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tenant: ''
    }
  },
  mounted () {
    this.tenant = this.selectedTenant
  },
  watch: {
    selectedTenant (newValue) {
      this.tenant = newValue
    }
  },
  methods: {
    onClickTenant (value) {
      this.tenant = value
      this.handleTenantSelect()
    },
    handleTenantSelect () {
      this.$emit('onTenantSelect', this.tenant)
    }
  }
}
